// extracted by mini-css-extract-plugin
module.exports = {"link":"TutorialLink_link__mrU89"};